import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-customer-product-price',
  templateUrl: './delete-customer-product-price.component.html',
  styleUrls: ['./delete-customer-product-price.component.css']
})
export class DeleteCustomerProductPriceComponent implements OnInit {

  customerProductPriceList:any = [];
  singleCustomerProductPriceList:any = [];
  id:any

  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(
    private generic_service: GenericService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
  }

  onTableDataChange(event: any) {
    this.pageNumber = event - 1;
    this.pageNumber1 = event;
    this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
  }

  getAllCustomerProductPrice(pageNumber: any,recordsPerPage: any){
    this.generic_service.getAllCustomerProductPrice(pageNumber,recordsPerPage).subscribe(
      (res:any)=> {
        console.log(res)
        this.customerProductPriceList = res.response.customerProductPriceList;
        this.totalRecords = res.response.totalRecords
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteDepartmentInfo(){
    this.generic_service.deleteCustomerProductPrice(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any){
    this.id = id
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

}

